/**
 * Landing behaviors, ported from design-ref/colorina-landing.html (C2: custom section behavior).
 *
 * Three jobs, all presentation-only: scroll-reveal (.reveal/.ladder/.bars gain .is-in), and the
 * sticky buy bar appearing once the hero scrolls away. No cart logic lives here — add-to-cart is
 * a native product form. Reduced motion short-circuits every effect to its final state.
 */
(() => {
  if (window.__colorinaLanding) return;
  window.__colorinaLanding = true;

  const init = () => {
    const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;

    const io = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (!entry.isIntersecting) continue;
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        }
      },
      { rootMargin: '0px 0px -12% 0px', threshold: 0.15 },
    );
    document
      .querySelectorAll('.cl-land .reveal, .cl-land .ladder:not(.is-in), .cl-land .bars')
      .forEach((el) => {
        if (reduce) el.classList.add('is-in');
        else io.observe(el);
      });

    const toggle = document.querySelector('.cl-land [data-menu-toggle]');
    const mobileNav = document.getElementById('cl-mobile-nav');
    if (toggle && mobileNav) {
      const setOpen = (open) => {
        toggle.setAttribute('aria-expanded', String(open));
        mobileNav.hidden = !open;
      };
      toggle.addEventListener('click', () => setOpen(mobileNav.hidden));
      mobileNav.addEventListener('click', (e) => {
        if (e.target.closest('a')) setOpen(false);
      });
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && !mobileNav.hidden) {
          setOpen(false);
          toggle.focus();
        }
      });
    }

    // language dropdown closes on outside click
    document.addEventListener('click', (e) => {
      document.querySelectorAll('.cl-land [data-lang-dd][open]').forEach((dd) => {
        if (!dd.contains(e.target)) dd.removeAttribute('open');
      });
    });

    const buybar = document.querySelector('.cl-land.buybar');
    const head = document.querySelector('.cl-land .site-head');
    const hero = document.querySelector('.cl-land .hero');
    if (hero) {
      new IntersectionObserver(
        (entries) => {
          const past = !entries[0].isIntersecting;
          if (buybar) buybar.classList.toggle('is-in', past);
          if (head) head.classList.toggle('is-stuck', past);
        },
        { rootMargin: '-70px 0px 0px 0px' },
      ).observe(hero);
    } else {
      // no hero on this page: solid header in normal flow, buy bar always visible
      if (buybar) buybar.classList.add('is-in');
      if (head) head.classList.add('is-stuck', 'site-head--static');
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
